import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import texts from '../../texts';
import styles from '../styles.module.scss';
import {ReactComponent as NoDataChart} from '../../../../images/noDataChart.svg';

export const EmptyState = () => {
    return (
        <Flex direction="column">
            <NoDataChart />
            <Text componentClasses={styles.emptyStateText}>{texts.chartEmptyState}</Text>
        </Flex>
    );
};
